<div class="dropdown" [class.dropdown--disabled]="disabled" [class.dropdown--invalid]="invalid" tabindex="0">
  <label class="form-label"
    ><span>{{ label || control.control['label'] }}</span>
    <ng-content select="[label]" />
  </label>

  <div class="dropdown__input" (click)="toggleExpand()">
    @if (hasValue) {
      <span class="dropdown__value">
        <ng-content select="prefix" />
        {{ labelFormatter ? labelFormatter(valueLabel) : valueLabel }}
        <ng-content select="suffix" />
      </span>
    } @else {
      <span class="dropdown__placeholder">{{ placeholder() }}</span>
    }

    <div class="dropdown__toggle">
      <div class="dropdown__icon">
        <app-icon [name]="isExpanded ? 'arrow_up' : 'arrow_down'" />
      </div>
    </div>
  </div>

  @if (isExpanded) {
    <div class="options-block">
      <ul class="options__list">
        @for (option of options; track option) {
          <li class="options__item" (click)="select(option.value)">{{ option.label }}</li>
        }
      </ul>
    </div>
  }
</div>

@if (isExpanded) {
  <div class="dropdown--overlay" (click)="closeDropdown()"></div>
}

@if (showError) {
  <span class="form-error">*{{ errorMessage }}</span>
}
